"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EventListenerManager_1 = require("../../DOM/EventTarget/EventListenerManager");
EventTarget.prototype.getEventListeners = function getEventListeners() {
    const listeners = EventListenerManager_1.default.getListeners(this);
    const result = {};
    listeners.forEach((item) => {
        var _a;
        const type = item.type;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        result[type] = (_a = result[type]) !== null && _a !== void 0 ? _a : [];
        result[type].push(item.listener);
    });
    return result;
};
//# sourceMappingURL=GetEventListeners.js.map